import Times from '~/bootcamp/Activities/components/Times'
import { range } from '~/utils/helpers'

export default function ExpressionNorwegian({
  multiplier,
  multiplicand,
  maxAnswerLen,
}: {
  multiplier: string
  multiplicand: string
  maxAnswerLen: number
}): React.ReactElement {
  const commonGridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${maxAnswerLen + 1}, minmax(0, 1fr))`,
  }

  return (
    <span className="self-end text-center text-md sm:text-lg font-semibold text-purple" style={commonGridStyle}>
      {range(multiplier.length).map((index) => (
        <span className="w-8 sm:w-10" key={`multiplier-expression-norwaygian-${index}`}>
          {multiplier[index]}
        </span>
      ))}
      <Times />
      {range(multiplicand.length).map((index) => (
        <span className="w-8 sm:w-10" key={`multiplicand-expression-norwaygian-${index}`}>
          {multiplicand[index]}
        </span>
      ))}
    </span>
  )
}
